<template>
  <q-page class="q-pa-xl centered-container-medium">
    <div class="row justify-start">
      <q-card
        class="fit"
        flat
      >
        <q-card-section class="row items-start justify-space-between">
          <div class="col">
            <span class="q-card-title">{{ $page.props.i18n.title }}</span>
          </div>
        </q-card-section>

        <q-card-section class="row q-pt-md q-col-gutter-md">
          <div class="col-xs-12 col-sm-12 col-md-12 col-12 self-stretch">
            <div
              v-for="item in items"
              :key="item.name"
              class="q-pa-md"
            >
              <q-item
                v-if="item.url"
                v-ripple
                clickable
                :href="item.url || ''"
                target="_blank"
                class="fit q-pa-lg q-card q-card--bordered no-shadow"
              >
                <q-item-section avatar>
                  <q-avatar :color="item.icon_color">
                    <q-icon
                      color="black"
                      :name="item.icon"
                      size="24px"
                    />
                  </q-avatar>
                </q-item-section>
                <q-item-section>
                  <q-item-label>{{ item.name }}</q-item-label>
                  <q-item-label
                    caption
                    class="text-muted"
                  >
                    {{ item.description }}
                  </q-item-label>
                </q-item-section>
              </q-item>

              <q-item
                v-if="item.chat_widget"
                v-ripple
                clickable
                class="fit q-pa-lg q-card q-card--bordered no-shadow"
                @click="$intercom.messages_open($page.props.shared.intercom)"
              >
                <q-item-section avatar>
                  <q-avatar :color="item.icon_color">
                    <q-icon
                      color="black"
                      :name="item.icon"
                      size="24px"
                    />
                  </q-avatar>
                </q-item-section>
                <q-item-section>
                  <q-item-label>{{ item.name }}</q-item-label>
                  <q-item-label
                    caption
                    class="text-muted"
                  >
                    {{ item.description }}
                  </q-item-label>
                </q-item-section>
              </q-item>
            </div>
          </div>
        </q-card-section>
      </q-card>
    </div>
  </q-page>
</template>
<script>
import Layout from '@/layouts/workspace.vue';

export default {
  components: {
  },
  layout: Layout,
  props: {
    items: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
    };
  },
  computed: {
  },
  watch: {
  },
  methods: {
  },
};
</script>
